export function getOther<T>(current: T, list: T[]): T {
  return list.find((e) => e !== current)!;
}

export function repeat(amount: number, callback: () => unknown): void {
  for (let i = 0; i < amount; i++) {
    callback();
  }
}

export function isSameType(typeObject: any, target: any): boolean {
  if (typeof typeObject === typeof target) {
    if (typeof typeObject === 'object') {
      return Object.keys(typeObject).every((key) => {
        return isSameType(typeObject[key], target[key]);
      });
    }
    return true;
  }

  return false;
}

export function replaceAll(str: string, search: string, replacement: string): string {
  return str.split(search).join(replacement);
}

export function capitalizeWord(word: string): string {
  const separator = "";
  const charList = word.split(separator);
  charList[0] = charList[0].toUpperCase();

  return charList.join(separator);
}

export function capitalizePhrase(phrase: string): string {
  const separator = " ";
  const words = phrase.split(separator);
  return words.map(capitalizeWord).join(separator);
}
